import { Dialog as MuiDialog } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Dialog = styled(MuiDialog)`
  .MuiPaper-root {
    width: 664px;
    min-width: 664px;
    height: 312px;
    border-radius: 12px;
    background: ${theme.colors.surfaceContainerBackground};
    padding: 32px;
  }

  .MuiDialogTitle-root {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    background: ${theme.colors.surfaceContainerBackground};
    padding: 0;

    .header {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      gap: 8px;
      flex: 1 0 0;
      width: 100%;

      .MuiIconButton-root svg path {
        fill: ${theme.colors.devicesSecondaryText};
      }

      .header-title {
        color: ${theme.colors.menuItemText};
        text-align: center;
        font-family: Quicksand, sans-serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 500;
        line-height: 42px;
        max-width: 500px;

        .capitalize {
          text-transform: capitalize;
        }
      }
    }
  }

  .MuiDialogContent-root {
    width: 100%;
    display: flex;
    padding: 0;

    .content-title {
      color: ${theme.colors.devicesSecondaryText};
      text-align: center;
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.25px;
      display: inline-block;
      padding: 24px 0 48px;

      span {
        font-weight: 600;

        &.capitalize {
          text-transform: capitalize;
        }
      }
    }
  }

  .MuiDialogActions-root {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    gap: ${theme.spacing.xSmall}px;

    .MuiButtonBase-root {
      width: 100%;
      margin-left: 0 !important;
    }
  }
`
